import API from "./api";

export const GetCompareNPIDetails = (baseUrl: string, userId: string) =>
    API.get(`${baseUrl}GetCompareNPIDetails?userId=${userId}`);